import { call, takeEvery } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

import { actionTypes } from './toastr-actions';

function* toast({ payload: { toastType, title, message, options } }) {
  const config = {
    ...options,
    showCloseButton: false
  };
  yield call(() => {
    toastr[toastType](title || '', message, config);
  });
}

export default function* toastrSaga() {
  yield takeEvery(actionTypes.TOAST_MESSAGE, toast);
}
